import { call, put, select } from 'redux-saga/effects';
import { setUser } from 'app/actions/user-session';
import { findLanguage } from 'mz-intl/core/languages';
import { redirectBack, showErrorNotification } from 'app/sagas/utils';
import { getUser, isTravelAgent } from 'app/sagas/selectors';
import { setCookie, removeCookie } from 'app/utils/cookie';
import getUserData from './getUserData';
import posthog from 'posthog-js';


export default function* doLoginSocial(action) {
  try {
    posthog.capture('Old Flow: User Successfully Signed In', { sign_in_method: action.payload.socialLoginType });

    yield put(setUser(action.payload.data));
    yield call(getUserData);

    // On login, we identify the user with the Chameleon api
    if (typeof chmln !== 'undefined') { // eslint-disable-line
      chmln.identify(window.mozioUser); // eslint-disable-line
    }

    // Persist the TA locale and pre-localize the redirect (see doLogin).
    const user = yield select(getUser);
    const isTA = yield select(isTravelAgent);
    const taLocale =
      isTA && user && user.language ? findLanguage(user.language).value : null;
    if (taLocale) {
      setCookie('ta-locale', taLocale, { days: 365 });
    } else {
      removeCookie('ta-locale');
    }

    yield call(redirectBack, taLocale);
  } catch (error) {
    yield put(setUser());
    yield call(showErrorNotification, {
      error,
      titleId: 'USER.LOGIN_ERROR_TITLE'
    });
  }
}
